export default __webpack_public_path__ + "static/media/RILAC-Logo1.26a59de7.svg";